import React, {useEffect, useState, useLayoutEffect, useRef, isValidElement} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import {getBannerMobile, getListcampaignV1, getListBanner} from '../../../service/campaignService';
import {getHotdeal} from "../../../service/hotdealService";

import {ResponsiveSliderTop, responsiveproductlistmobile4,responsiveproductlistmobile, responsiveproductlistmobile5}  from "../../../utils/constant";
import { ItemHotDeal, ItemProductGift, Item} from "../../../components/mobile/product";
import {getMyProduct, getcategory} from "../../../service/myProductService";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import Function from "../../../components/mobile/Function/function";
import {pushtracking} from '../../../service/trackingService';
import { getPaymentCount } from "../../../service/cartService";
// import Head from "../../../components/Head";
import {Helmet} from "react-helmet";
import platform from 'platform';
// import './css/index.css';
import { toast } from "react-toastify";
import Carousel from "react-multi-carousel";
require("react-multi-carousel/lib/styles.css");

function ServerSideComponent({ serverData }){
    const handleClick=(uri)=>{
        if(uri.includes('http')===true){
            window.location.href = uri;
        }else{
            window.location.href = uri;
        }
    }
    return(
        <div className="row mgt-10 mgx-0" id="home-banner">
        {  
            serverData.length>0?(
                <Carousel
                    ssr={true}
                    responsive={ResponsiveSliderTop}
                    showDots={true}
                    autoPlay={true}
                    autoPlaySpeed={5000}
                    infinite={true}
                    >
                    {
                        serverData.map((item,i)=>{
                            return <div  key={i} className="slider-top">
                                    <img onClick={()=>handleClick(item.link)} src={item.images} alt={item.name} title={item.name}/>
                            </div>
                        })
                    }
                
                </Carousel>
            ):(<div style={{height:360}}></div>)
        }
        </div>
    )
    
  }
function ServerFunctionComponent({ serverData }){
    const handandleRedirect=(uri)=>{
        window.location.href = uri;
    }
    return(
        <div className="row mgt-10 banner-title pdt-10 pdx-10 mgx-0" id="tien-ich">
            <Carousel key="function"  responsive={responsiveproductlistmobile5}>
                <div className="banner-item">
                    <div className='row' onClick={()=>handandleRedirect('/san-xu.html')}>
                        <div className='col-12'>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/san_xu.png" alt="icon"/>
                            </div>
                        <div className='col-12 d-flex in-f pdb-5'><span>Săn xu</span></div>
                    </div>
                </div>
                <div className="banner-item">
                    <div className='row' onClick={()=>handandleRedirect('/dong-gia.html')}>
                        <div className='col-12'>
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/dong_gia.png" alt="icon"/>
                            </div>
                        <div className='col-12 d-flex in-f pdb-5'><span>Đồng giá</span></div>
                    </div>
                </div>
                <div className="banner-item">
                    <div className='row'  onClick={()=>handandleRedirect('/giam-gia.html')}>
                        <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/giam_gia.png" alt="icon"/></div>
                        <div className='col-12 d-flex in-f pdb-5'><span>Giảm giá</span></div>
                    </div>
                </div>
                <div className="banner-item">
                    <div className='row'  onClick={()=>handandleRedirect('/hang-moi-ve.html')}>
                        <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/hang_moi.png" alt="icon"/></div>
                        <div className='col-12 d-flex in-f pdb-5'><span>Hàng mới</span></div>
                    </div>
                </div>
                <div className="banner-item">
                    <div className='row' onClick={()=>handandleRedirect('/he-thong-cua-hang.html')}>
                        <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cua_hang.png" alt="icon"/></div>
                        <div className='col-12 d-flex in-f pdb-5'><span>Cửa hàng</span></div>
                    </div>
                </div>
                <div className="banner-item">
                    <div className='row' onClick={()=>handandleRedirect('/dac-quyen.html')}>
                        <div className='col-12'><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/dac_quyen.png" alt="icon"/></div>
                        <div className='col-12 d-flex in-f pdb-5'><span>Đặc Quyền</span></div>
                    </div>
                </div>
            </Carousel>
        </div>
    )
  }

  function ServerHotdealComponent({ serverData }){
    const handleClickRedirect =(uri)=>{
        window.location.href = uri;
    }
    return(
        <div className="row mgx-0">
            <div className="col-6 header-left">
                <span className="hotdeal-text">HOTDEAL</span>
            </div>
            <div className="col-6 header-right pdr-10">
                <span onClick={()=>handleClickRedirect('/hot-deal.html')}>Xem thêm</span>
                <i className="fa fa-angle-right fa-1"></i>
                <i className="fa fa-angle-right fa-1"></i>
            </div>
        </div>
    )
    
  }
  function ServerGiftComponent(serverData){
    const handleClickRedirect =(uri)=>{
        window.location.href = uri;
    }
    return(
    <div className="row mgx-0">
        <div className="col-8 header-left">
            <span className="product-gift">MUA HÀNG TẶNG QUÀ</span>
        </div>
        <div className="col-4 header-right pdr-10">
            <span onClick={()=>handleClickRedirect('/mua-hang-tang-qua.html')}>Xem thêm</span>
            <i className="fa fa-angle-right fa-1"></i>
            <i className="fa fa-angle-right fa-1"></i>
        </div>
    </div> 
    )
    
  }

  
const Home = ({serverData})=> {
    const [scrollPosition, setPosition] = useState(0);
    const [itemPopup, setItemPopup] = useState([]);
    const getDataPopup=()=>{
        getBannerMobile('M002').then((respose)=>{
            if(+respose.status === 200 && respose.message !== "Không tìm thấy dữ liệu."){
                setItemPopup(respose.message);
            }
        });
    }

    const [listBannerDownload, setListBannerDownload] = useState([]);
    const getDataBannerDownload=()=>{
        getBannerMobile('M006').then((response)=>{
            if(+response.status === 200  && response.message !== "Không tìm thấy dữ liệu."){
                setListBannerDownload(response.message);
            }
        });
    }
    // const [meta, setMeta] = useState();
    const [itemData, setItemData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [groupId, setGroupId] = useState('');
    const [loadMoreStart, setLoadMoreStart] = useState(0);
    const fetchDataHotdeal = (start) => {
        let param = {
            div:  null,
            brands: null,
            group: null,
            hotdeal_date: null,
            current_page: start,
            per_page: 3
          };
        try{
            getHotdeal(param).then((response) => {
                if(response.status !== 426 || response.status !== 500){
                    if(response.status === 200 && response.message.length >0){
                        setItemData((prevData) => [...prevData, ...response.message]);
                        setTotalItem(response.metadata?.total_item);
                    }
                }                
              });
        }catch(e){
            console.log(e);
        }
    };

    var [dataGiftList, setDataGiftList] = useState([]);
    const getDataProductGift=()=>{
        getListcampaignV1(0,4).then((response) => {
            if(response.status === 200  && response.message !== "Không tìm thấy dữ liệu."){
                setDataGiftList(response["message"]);
            }
        }); 
    }
    
    const [itemDataProduct, setItemDataProduct] = useState([]);
    const [totalItemProduct, setTotalItemProduct] = useState(0);
    const [loadMoreStartProduct, setLoadMoreStartProduct] = useState(0);
    const getDataProduct = (start,div,groups) => {
        try{//(category, page, divisions, functions, groups, text_search, tag=''
            getMyProduct('', start, div, '', groups,'').then((response) => {
                if(response.status == 200 && response.message.length >0  && response.message !== "Không tìm thấy dữ liệu."){
                    setItemDataProduct((prevData) => [...prevData, ...response.message]);
                    setTotalItemProduct(+response.metadata?.total_item);
                }               
              });
        }catch(e){
            console.log(e);
        }
      
    };

    const [category, setCategory] = useState([]);
    const [childCategory, setChildCategory] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [childBefor, setChildBefor] = useState([]);
    const getDataCategory=()=>{
        try{
            getcategory().then((response) => {
                if(response.status == 200 && response.message.length >0){
                    setCategory(response.message);
                    var obj = {};
                    setCategoryId(response.message[0]._id);
                    response.message.forEach(element => {
                        if(element.children.length>0){
                            obj[element._id] = element.children;
                        }
                    });
                    setChildCategory(obj);
                    setChildBefor(response.message[0].children);
                    getDataProduct(0, response.message[0]._id,'');
                }               
              });
        }catch(e){
            console.log(e);
        }
    }
    const divTienIch = useRef();
    const divHotdeal = useRef();
    const divSanqua = useRef();
    const divDanhmuc = useRef();
    const [fgScroll, setFgScroll] = useState(false);
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();
        return () =>  window.removeEventListener('scroll', updatePosition);
    }, []);
    const [showPopup, setShowPopup] = useState(false);
    const time = new Date();

    const [countPay, setCountPay] = useState(0);
        const loadCount = ()=>{
            if(window.localStorage.getItem('key')){
                getPaymentCount(window.localStorage.getItem('key')).then((response)=>{
                    if(response.status === 200){
                        setCountPay(response.message);
                    }
                })
            } 
        }

        const [showPopupPayment, setShowPopupPayment] = useState(true);
        const [showApp, setShowApp] = useState(true);
        const [showBanner, setShowBanner] = useState(true);
    useEffect(()=>{
        setItemDataProduct([]);
        window.scrollTo(0,0);
        time.setSeconds(time.getSeconds());
        getDataPopup();
        getDataCategory();
        // getDataBanner();
        getDataBannerDownload();
        setLoadMoreStart(0);
        setItemData([]);     
        fetchDataHotdeal(0); 
        getDataProductGift();
        setLoadMoreStartProduct(0);
            var pageView = sessionStorage.getItem("pageView");
            if (pageView == null) {
                setTimeout(() => {
                    setShowPopup(true);
                    try{
                        if(platform.product !== 'iPhone'){
                            let _link = "bibomart://";
                            window.location.replace(_link);
                        }
                    }catch(e){console.log(e)}
                }, 1000); 
                pageView = 1;
            } 
            sessionStorage.setItem("pageView", pageView);

            try{
                pushtracking(window.localStorage.getItem('sessionId')??null,
                window.localStorage.getItem('_id')??null,
                window.localStorage.getItem('phone')??null ,
                 '/', "Trang chủ", 0,0,'index','inWeb',[],'Website PC').then((response)=>{
                    console.log('send tracking');
                });
            }catch(e){console.log(e)}
            
            loadCount();
            setShowApp(true);
            setShowBanner(true);
            loadBannerPopup();
    },[]);

    const handleClick=(uri)=>{
        if(uri.includes('http')===true){
            window.location.href = uri;
        }else{
            window.location.href = uri;
        }
    }

    const handleLoadMoreProduct = () => {
        setLoadMoreStartProduct(0);
        const newStart = loadMoreStartProduct + 1;
        setLoadMoreStartProduct(newStart);
        getDataProduct(newStart,categoryId,groupId);
    };
      
    const handleClickRedirect =(uri)=>{
        window.location.href = uri;
    }
    
    const handleClickGetProductByCategiryId=(id)=>{
        setCategoryId(id);
        setChildBefor(childCategory[id]);
        setLoadMoreStartProduct(0);
        setItemDataProduct([]);
        getDataProduct(0,id,'');
    }
    
    const handleClickGetProductBygroupId=(id)=>{
        setGroupId(id);
        setLoadMoreStartProduct(0);
        setItemDataProduct([]);
        getDataProduct(0, categoryId ,id);
    }
    
    const handleClickDownload =()=>{
        // if(operatingSystem === 'iOS'){
        //     window.location.replace(yourIOSDeepLink);
        // }else{
        //     window.location.replace(yourAndroidDeepLink);
        // }
        window.location.replace('https://onelink.to/tf6fk5');
    }
    
    const handleClosePopup=()=>{
        setShowPopup(false)
    }
    const InfiniteScroll = ({ loadMore }) => {
        try {
            useEffect(() => {
                const handleScroll = () => {
                    var check = Math.abs(parseInt(window.innerHeight +document.documentElement.scrollTop) - parseInt(document.documentElement.offsetHeight)) 
                    if (check === 0 || check === 1) {
                     loadMore();
                  }
                };
            
                window.addEventListener("scroll", handleScroll);
                return () => {
                  window.removeEventListener("scroll", handleScroll);
                };
              }, [loadMore]);
        } catch (error) {
            toast.warning(error);
        }
        return null;
    };
    const HandleScroll=(top)=>{
        window.scrollTo(+top+40, +top+40);
    }

    const handelListPayNow=()=>{
        window.location.href='/mobile/orders.html';
        window.localStorage.setItem('tabOrder', -2);
    }

    const handandleRedirect=(uri)=>{
        window.location.href = uri;
    }
    const hanldeCloseapp = ()=>{
        setShowApp(false);
    }
    const handleOpentApp=()=>{
        try{
            let _link = "bibomart://";
            window.location.replace(_link);
        }catch(e){}
        setTimeout(() => {
            window.location.replace('https://onelink.to/tf6fk5');
        }, 2000); 
       
    }

    const [bannerPopup, setBannerPopup] = useState([]);
    const loadBannerPopup=()=>{
        try {
            getListBanner('W015T01').then((response)=>{
                if(response.status === 200 && response['message'] !== 'Không tìm thấy dữ liệu.'){
                    setBannerPopup(response['message']);
                }
            })
        } catch(err) {
          console.error(err);
        }  
    }
    const handleCloseBanner=()=>{
        setShowBanner(false);
    }
    let isScrolling;
    useLayoutEffect(() => {
        window.addEventListener('scroll', () => {
            window.clearTimeout(isScrolling);
            setFgScroll(true);
            isScrolling = setTimeout(function () {
                setFgScroll(false);
              }, 100); 

          });
        
    }, []);

  return (
   <Layout>

{
        showApp ? (
            <div className="position-fix box-app w-100 ">
            <div className="row align-items-center">
                <div className="col-1 close">
                    {/* <span>X</span> */}
                    <img src="/static/image/icon_close.png" alt="colse" onClick={hanldeCloseapp}/>
                </div>
                <div className="col-9 body d-flex align-items-start">
                    <div className="logo">
                        <img src="/static/image/LogoApp.png" alt="" />
                    </div>
                    <div className="box-conent-app">
                        <div className="title">Bibo Mart - Siêu thị mẹ và bé</div>
                        <div className="company">Bibomart TM Joint Stock Company</div>
                        <div><img src="/static/image/Stars.png" alt="" />
                        <img src="/static/image/Stars.png" alt="" />
                        <img src="/static/image/Stars.png" alt="" />
                        <img src="/static/image/Stars.png" alt="" />
                        </div>
                        <div className="footer">
                            NHẬN - Trên App Store
                        </div>
                    </div>
                    
                </div>
                <div className="col-2 more-info">
                    <span onClick={handleOpentApp}>Xem </span>
                </div>
            </div>
            </div>
        ):(null)
    }

    <h1 className="d-none">bibomart, shop mẹ và bé, cửa hàng mẹ bé</h1>
    <Helmet>
        <body className="bg-index"/>
    </Helmet>
     {
        showPopup && itemPopup.length > 0?(
            <div className="show-poppup">
                <div className="icon-delete in-f" onClick={handleClosePopup}><i className="fa fa-xmark close-result-search"></i></div>
                <div className="item-body">
                    <img src={itemPopup[0].images}/>
                </div>    
            </div>
        ):(null)
    }
    <div className="index">
        <HeaderMobile Type={'Header1'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} />
        <div className="row list-banner list-menu-neo mgt-5 filter pdx-5 bg-white pdb-10 mgx-0" 
        style= {scrollPosition > 35 && scrollPosition < 1900 ?({"display":'flex'}):({"display":'none'})}
        >
                {
                    platform.name === "Safari" || platform.product === "iPhone" ? (
                        <Carousel key="category-finction-iphone"
                        responsive={responsiveproductlistmobile4}
                        >
                        <div className={scrollPosition > 35 && scrollPosition < 280 ? ("menu-neo-detail pdx-12 selected-color-red mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                            <a onClick={()=>handleClickRedirect('/ket-qua-tim-kiem.html')}><span>Tìm kiếm</span></a>
                            </div>
                            <div className={scrollPosition > 280 && scrollPosition < 480 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                            <a onClick={()=>HandleScroll(280)}><span>Tiện ích</span></a>
                            </div>
                            {
                                itemData.length >0 ?(
                                    <div className={scrollPosition > 480 && scrollPosition < 1000 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                                        <a onClick={()=>HandleScroll(480)}><span>Hot Deal</span></a>
                                    </div>
                                ):(null)
                            }
                            {
                                dataGiftList.length >0 ?(
                                <div className={scrollPosition > 1000 && scrollPosition < 1580 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                                    <a onClick={()=>HandleScroll(1000)}><span>Săn quà</span></a>
                                </div>
                                ):(null)
                            }
                            <div className={scrollPosition > 1580 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                                <a onClick={()=>HandleScroll(1580)}><span>Danh mục</span></a>
                            </div>
                        </Carousel>
                        
                    ):(
                        <Carousel key="category-finction"
                        responsive={responsiveproductlistmobile4}>
                        <div className={scrollPosition > 35 && scrollPosition < 280 ? ("menu-neo-detail pdx-12 selected-color-red mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                            <a onClick={()=>handleClickRedirect('/ket-qua-tim-kiem.html')}><span>Tìm kiếm</span></a>
                            </div>
                            <div className={scrollPosition > 280 && scrollPosition < 480 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                            <a href="#tien-ich"><span>Tiện ích</span></a>
                            </div>
                            {
                                itemData.length >0 ?(
                                    <div className={scrollPosition > 480 && scrollPosition < 1000 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                                        <a href="#hot-deal"><span>Hot Deal</span></a>
                                    </div>
                                ):(null)
                            }
                            {
                                itemData.length >0 ?(
                                <div className={scrollPosition > 1000 && scrollPosition < 1580 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                                    <a href="#san-qua"><span>Săn quà</span></a>
                                </div>
                                ):(null)
                            }
                            <div className={scrollPosition > 1580 ? ("menu-neo-detail pdx-12 selected-color-red  mgr-5"):("menu-neo-detail pdx-12  mgr-5")}>
                                <a href="#danh-muc"><span>Danh mục</span></a>
                            </div>
                            </Carousel>
                    )
                }
            
            
        </div>
        
        <ServerSideComponent serverData={serverData.DataSlider?.message}/>
        <div  ref={divTienIch}></div>
        {/* <Function/> */}

        <ServerFunctionComponent serverData={null}/>
        
        {
            listBannerDownload.length > 0?(
                <div className="row mgt-5">
                    <img onClick={handleClickDownload} src={listBannerDownload[0].images} alt="download" title="download"/>
                </div>
            ):(null)
        }
        {
            itemData.length >0 ?(
                <div ref={divHotdeal} className="row mgt-10 bg-detail" id="hot-deal">
                    <ServerHotdealComponent  serverData={null}/>
                    <div className="col-12 mgt-5 item-hotdeal">
                        <ul>
                            {
                            itemData.map((item, i)=>{
                                return <ItemHotDeal key={i} item={item} index={time+item.sku+i}/>
                            })
                            }
                        </ul>                        
                    </div>
                </div>
            ):(null)
        }
        {
            
            scrollPosition > 150  && dataGiftList.length > 0 ? (
                <div  ref={divSanqua}  className="row mgt-10 bg-detail" id="san-qua">
                    <ServerGiftComponent  serverData={null}/>
                    <div className="row mgt-10 pdx-5">
                        <ul className="row col-ul-1">
                            {
                                dataGiftList.length > 0 ? (
                                    dataGiftList.map((item, i)=>{
                                        return <ItemProductGift key={i} item={item} index={time+item.sku+i}/>
                                    })
                                ):
                                (
                                <li>
                                    <div>Không có sản phẩm</div>
                                </li>
                                )    
                            }
                        </ul>
                    </div>
                </div>   
            ):(null)
        }
        {
            scrollPosition > 400 ? (
            <><div ref={divDanhmuc} id="danh-muc" className="row mgt-10 menu-home-second mgx-0 pdx-5 bg-white">
                {
                    category.length>0?(
                        <Carousel key="category"
                        responsive={responsiveproductlistmobile4}
                        ssr={true}
                        >
                        {
                            category.map((item, i)=>{
                                return <div key={i} className={+categoryId === +item._id ? ("banner-item select-menu"):("banner-item") } onClick={()=>handleClickGetProductByCategiryId(item._id)}>
                                    <div className='row mgx-0'>
                                        <div className='col-12'><img src={item.icon?.selected} alt={item.name}/></div>
                                        <div className='col-12 d-flex pdx-5 pdy-5'><span>{item.name}</span></div>
                                    </div>
                                </div>
                            })
                        }
                        </Carousel>
                        
                    ):(null)
                }
            </div>
        
        <div className={scrollPosition > 1900 ?("row list-banner mgt-5 filter pdx-5 bg-white fix-position mgx-0"):("row list-banner pdx-10 bg-white")}>
            {
                childBefor?.length>0?(
                    
                        scrollPosition > 1900 ? (
                            <>
                            <div className="col-1 all-category">
                               <a href="#danh-muc"><img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/menu_logo.png" alt="icon"/></a> 
                            </div>
                            <div className="col-11">
                            <Carousel key="categoryChild"
                            responsive={responsiveproductlistmobile}
                            > 
                            {
                                childBefor?.map((item, i)=>{
                                    return <div key={i} className={+groupId === +item._id ? ("list-menu-detail selected-color-red"):("list-menu-detail") } onClick={()=>handleClickGetProductBygroupId(item._id)}>
                                                <span>{
                                                item?.name?.length > 10 ? ( (item?.name).substring(0, 10) +'...') :(item?.name)
                                                }</span>
                                            </div>
                                })
                            }
                            </Carousel>
                            </div>
                            </>
                        ):(<Carousel key="categoryChild"
                        responsive={responsiveproductlistmobile}
                        >
                        {
                            childBefor?.map((item, i)=>{
                                return <div key={i} className={+groupId === +item._id ? ("list-menu-detail selected-color-red"):("list-menu-detail") } onClick={()=>handleClickGetProductBygroupId(item._id)}>
                                            <span>{
                                            item?.name?.length > 10 ? ( (item?.name).substring(0, 10) +'...') :(item?.name)
                                            }</span>
                                        </div>
                            })
                        }
                        </Carousel>) 
                ):(null)
            }
        </div>
        <div className="row bg-white pdx-5">
            <ul className="row col-ul-1">
                {
                    itemDataProduct.length > 0 ? 
                    (
                        itemDataProduct.map((item, j)=>{
                           return <Item key={j} item={item} index={time+item.sku+j}/>
                        })
                    )
                    :
                    (null)
                }                
            </ul>
            <InfiniteScroll loadMore={handleLoadMoreProduct} />
            {
                +totalItemProduct - +itemDataProduct.length >0 ?(
                    <div className="loading-page-app-item pdy-5" style={{textAlign:"center"}}> <img src="/../images/loading.gif" alt="icon"/></div>
                ):(null)
            }
            
        </div>
        </>
        ):(null)
        }
    </div>
    {
        countPay > 0 && showPopupPayment === true ?(
                <div className="pay-now text-span d-flex justify-content-between">
                    <div style={{alignContent:'center'}}>
                        <span>
                            Bạn có đơn hàng đang chờ thanh toán. <span className="pay-now-link" onClick={()=>handelListPayNow()}>Thanh toán ngay!</span>
                        </span>
                    </div>
                    <div>
                        <span className="text-right close-poppup" onClick={()=>setShowPopupPayment(!showPopupPayment)}>x</span>
                    </div>
                    
                </div> 
        ):(null)
    }
    
    {
        bannerPopup.length>0 && showBanner ? (
        //banner-show-app
            <div className={fgScroll?("banner-hide-app"):("banner-show-app")}>
            <div className="">
                <div className="close-banner align-items-center pointer" onClick={handleCloseBanner}><span>x</span></div>
                <div className="img-banner"><a href={bannerPopup[0].link}><img src={bannerPopup[0].images} alt={bannerPopup[0].name} /></a></div>
            </div>
            </div>
        ):(null)
    }   

   </Layout>
  )
}

export default Home;
